import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function RedLentilCurry() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Red Lentil Curry</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>
        <b>For the Red Lentil Curry:</b>
        <br></br>2 tablespoons coconut oil (or olive oil)<br></br>1 large onion,
        peeled and chopped<br></br>2 cups diced carrots<br></br>
        3-4 cloves garlic, minced<br></br>2 tablespoons fresh grated ginger
        <br></br>
        2+ tablespoons thai red curry paste<br></br>2 teaspoons ground cumin
        <br></br>1 teaspoon salt<br></br>
        16 ounce dried red lentils<br></br>6 cups vegetable broth<br></br>
        15 ounce can crushed tomatoes<br></br>
        14 ounce can unsweetened coconut milk<br></br>
        <b>For the Pickled Onions:</b>
        <br></br>
        1/2 red onion, sliced<br></br>
        1/2 cup water<br></br>
        1/4 cup apple cider vinegar<br></br>1 tablespoon palm sugar (or your
        preferred sweetener)<br></br>
        1/2 teaspoon salt<br></br>
        <b>Additional Garnishes:</b>
        <br></br>1 cup cashews<br></br>1 cup cilantro<br></br>
      </Typography>

      <Typography>
        For the Pickled Onions: In a small microwave-safe bowl mix the water,
        vinegar, sugar, and salt. Microwave for 60-90 seconds to dissolve the
        sugar. Slice the onions thin. Then mix them into the pickling water.
        Allow them to soak as you make the lentil curry.
        <br>
          <br></br>
        </br>
        For the Red Lentil Curry: Chop the onions, carrots, garlic and grate the
        ginger. Set a large 6-8 quart pot over medium heat. Add the oil.
        <br>
          <br></br>
        </br>
        Once hot, add the onions, carrots, garlic, ginger, 2-5 tablespoons curry
        paste, cumin, and salt. Saute until the onions are soft and tender. *If
        your curry paste tastes/smells very spicy, add only 2 tablespoons. You
        can always add more later.
        <br>
          <br></br>
        </br>
        Pour in the dried red lentils, chicken broth, crushed tomatoes, and
        coconut milk. Stir well. Simmer for 20 minutes, stirring every 3-5
        minutes, so the lentils don't stick to the bottom of the pot.
        <br>
          <br></br>
        </br>
        If the liquid seems to absorb before the lentils are fully cooked, add
        some water to loosen up the mixture. After 20 minutes, the lentil curry
        should be soft and thick.
        <br>
          <br></br>
        </br>
        Drain the pickled onions. Serve the lentil curry warm, on its own, with
        rice, or with baby spinach. Top with pickled onions, cashews, and
        cilantro leaves.
        <br>
          <br></br>
        </br>
      </Typography>
    </Card>
  );
}
